import styled from '@emotion/styled';
import SubNavigation from 'components/Navigation/SubNavigation';
import { CardBasic } from 'components/Card/Card';
import css from '@emotion/css';

export const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;

export const NavWrapper = styled.div`
  max-width: 600px;
  position: relative;
  margin: 0 auto;
`;

export const PageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  position: relative;
  max-width: 1372px;
`;

export const ContentCard = styled(CardBasic)<{ loadable?: boolean }>`
  ${({ loadable }) =>
    loadable
      ? css`
          position: relative;
          overflow: hidden;
        `
      : ''}
  padding: 20px;
`;
